import { Navigate } from 'react-router';
import { useSelector } from 'react-redux';
import { userSelectors } from 'src/selectors';
import { PATH_PAGE } from 'src/routes/paths';

// ----------------------------------------------------------------------

/**
 * AdminGuard - Protects admin routes
 * Checks if user has system-level role (systemId = 1)
 */
export default function AdminGuard({ children }) {
  const user = useSelector(userSelectors.getUser());

  // Check if user has system-level role (systemId = 1)
  const hasAdminAccess = user?.userRoles?.some((ur) => ur.systemId === 1);

  if (!hasAdminAccess) {
    return <Navigate to={PATH_PAGE.workspaces} replace />;
  }

  return <>{children}</>;
}
